/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ApplicationHealthRequestFilter {
    getFixupPrototypeFunction() { return ApplicationHealthRequestFilter.fixupPrototype; }

    static newInstance(model: Partial<ApplicationHealthRequestFilter>): ApplicationHealthRequestFilter {
        let obj = Object.assign(new ApplicationHealthRequestFilter(), model);
        ApplicationHealthRequestFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ApplicationHealthRequestFilter>): ApplicationHealthRequestFilter {
        if (!model) return null;
        return ApplicationHealthRequestFilter.newInstance(<ApplicationHealthRequestFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ApplicationHealthRequestFilter) {
        if (!obj) return;

        models.ApplicationHealthRequestFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ApplicationHealthRequestFilter): boolean {
        Object.setPrototypeOf(obj, ApplicationHealthRequestFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.filter) {
            models.QueryOperator.fixupPrototype(this.filter);
        }
    }

    /**
     * Query expression to filter application health data.
     */
    filter: models.QueryOperator;

    /**
     * Start date for filtering alerts
     */
    start_date: Date;

    /**
     * End date for filtering alerts
     */
    end_date: Date;

}
